import React from 'react'
import PropTypes from 'prop-types'
import { connect } from 'react-redux'
import { selectPreSaleFlag, selectCustomer } from '../App/selectors'
import { selectPhoneInfo } from './selectors'
import { Specs } from '../../components'
import { createEvent } from '../UserEvents/actions'
import { selectStarterContent } from '../GettingStarted/selectors'
import { DeviceNotLoadedHOC } from '../../hocs'

const proptypes = {
  currentPhoneInfo: PropTypes.oneOfType([PropTypes.object]).isRequired,
  preSaleFlag: PropTypes.bool.isRequired,
  createUserEvent: PropTypes.func.isRequired,
  customer: PropTypes.string.isRequired,
}

const SpecsContainer = ({
  currentPhoneInfo,
  preSaleFlag,
  createUserEvent,
  customer,
  startercontent,
}) => {
  return (
    <Specs
      currentPhoneInfo={currentPhoneInfo}
      preSaleFlag={preSaleFlag}
      createUserEvent={createUserEvent}
      customer={customer}
      startercontent={startercontent}
    />
  )
}

const mapStateToProps = state => ({
  preSaleFlag: selectPreSaleFlag(state),
  currentPhoneInfo: selectPhoneInfo(state),
  customer: selectCustomer(state),
  startercontent: selectStarterContent(state),
})

// eslint-disable-next-line
const mapDispatchToProps = dispatch => ({createUserEvent: event => dispatch(createEvent(event))})
SpecsContainer.propTypes = proptypes

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(DeviceNotLoadedHOC(SpecsContainer))



// WEBPACK FOOTER //
// ./src/containers/Specs/Specs.js